<div class="ant-form-item-label" [class.se__nolabel]="hideLabel || !label" [style.width.px]="_labelWidth">
  @if (label) {
    <label [attr.for]="_id" class="se__label" [class.ant-form-item-required]="required" [class.se__no-colon]="_noColon">
      <span class="se__label-text">
        <ng-container *nzStringTemplateOutlet="label">{{ label }}</ng-container>
      </span>
      @if (optional || optionalHelp) {
        <span class="se__label-optional" [class.se__label-optional-no-text]="!optional">
          <ng-container *nzStringTemplateOutlet="optional">{{ optional }}</ng-container>
          @if (optionalHelp) {
            <nz-icon
              nz-tooltip
              [nzTooltipTitle]="optionalHelp"
              [nzTooltipColor]="optionalHelpColor"
              nzType="question-circle"
            />
          }
        </span>
      }
    </label>
  }
</div>
<div class="ant-form-item-control se__control">
  <div class="ant-form-item-control-input {{ controlClass }}">
    <div class="ant-form-item-control-input-content" (cdkObserveContent)="checkContent()" #contentElement>
      <ng-content />
    </div>
  </div>
  @if (showErr) {
    <div @helpMotion class="ant-form-item-explain ant-form-item-explain-connected">
      <div role="alert" class="ant-form-item-explain-error">
        <ng-container *nzStringTemplateOutlet="_error">{{ _error }}</ng-container>
      </div>
    </div>
  }
  @if (extra && !compact) {
    <div class="ant-form-item-extra">
      <ng-container *nzStringTemplateOutlet="extra">{{ extra }}</ng-container>
    </div>
  }
</div>
